import {Stack, styled} from '@mui/material';

const StyledStack = styled(Stack)`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 418px;
	height: 190px;

	${({theme}) => theme.breakpoints.down('sm')} {
		width: calc(100% - 32px);
	}

	&:focus-visible {
		outline: none;
	}
`;

export {StyledStack};
